"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFuturesTickersFetching = exports.getLatestFuturesTicker = exports.getFuturesTickersState = exports.getFuturesTickersList = exports.getFuturesTickersInterval = exports.getFormattedFuturesTickers = void 0;
var _reselect = require("reselect");
// Basic selectors
var getFuturesTickersState = exports.getFuturesTickersState = function getFuturesTickersState(state) {
  return state.futures.tickers;
};
var getFuturesTickersList = exports.getFuturesTickersList = function getFuturesTickersList(state) {
  return getFuturesTickersState(state).tickers;
};
var getFuturesTickersInterval = exports.getFuturesTickersInterval = function getFuturesTickersInterval(state) {
  return getFuturesTickersState(state).interval;
};
var isFuturesTickersFetching = exports.isFuturesTickersFetching = function isFuturesTickersFetching(state) {
  return getFuturesTickersState(state).fetching;
};

// Memoized selector for formatted tickers data
var getFormattedFuturesTickers = exports.getFormattedFuturesTickers = (0, _reselect.createSelector)([getFuturesTickersList], function (tickers) {
  if (!tickers || !tickers.length) return [];
  return tickers.map(function (ticker) {
    return {
      // Assuming ticker format is similar to standard tickers
      // Format: [EndDateTime, OpenPrice, HighPrice, LowPrice, ClosePrice, Volume, etc.]
      time: new Date(ticker[0]).valueOf(),
      // Convert to timestamp
      open: parseFloat(ticker[1]),
      high: parseFloat(ticker[2]),
      low: parseFloat(ticker[3]),
      close: parseFloat(ticker[4]),
      volume: parseFloat(ticker[5])
      // Add any additional fields that might be needed
    };
  });
});

// Add more selectors as needed for specific data transformations
var getLatestFuturesTicker = exports.getLatestFuturesTicker = (0, _reselect.createSelector)([getFormattedFuturesTickers], function (tickers) {
  return tickers.length ? tickers[tickers.length - 1] : null;
});